<div class="v4-layout-form" [formGroup]="priceForm">
  <div class="v4-layout-form-title">
    {{ "property-property_detail-booking_setting_html_价格" | translate }}
    <!-- Pricing -->
  </div>
  <div class="v4-layout-field">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_基础价格" | translate }}
      <!-- Base price -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[180px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'property-property_detail-booking_setting_html_基础价格' | translate"
          formControlName="base_price" />
      </div>
    </div>
  </div>
  <div class="v4-layout-field" *ngIf="!isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_周末价格" | translate }}
      <!-- Weekend price -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[180px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'property-property_detail-booking_setting_html_周末价格' | translate"
          formControlName="weekend_price" />
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_周末价格说明" | translate }}
        <!-- Price for Friday and Saturday nights. -->
      </div>
    </div>
  </div>

  @if (isVrbo) {
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "property-property_detail-booking_setting_html_每日价格" | translate }}
        <!-- Night of week pricing -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <label nz-checkbox [(ngModel)]="vrboEnableNightlyRate" [ngModelOptions]="{ standalone: true }">
            {{ "property-property_detail-booking_setting_html_启用" | translate }}
            <!-- Enabled -->
          </label>
        </div>
      </div>
    </div>

    @if (vrboEnableNightlyRate) {
      @for (day of optionsOfNightlyRate; track $index) {
        <div class="v4-layout-field" formGroupName="nightly_rate">
          <div class="v4-layout-field-label">{{ day.label }}</div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                class="w-[180px]"
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'word.price' | translate"
                [formControlName]="day.value" />
            </div>
          </div>
        </div>
      }
    }

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "property-property_detail-booking_setting_html_周折扣" | translate }}
        <!-- Weekly discount -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative w-[180px]">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.discount' | translate"
            formControlName="weekly_discount" />
          <span class="percent">%</span>
        </div>
        <div class="v4-layout-field-extra">
          {{ "property-property_detail-booking_setting_html_周折扣说明" | translate }}
          <!-- Weekly discounts apply to reservations that are 7 days or longer. 30% means 30% off. -->
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "property-property_detail-booking_setting_html_月折扣" | translate }}
        <!-- Monthly discount -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative w-[180px]">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.discount' | translate"
            formControlName="monthly_discount" />
          <span class="percent">%</span>
        </div>
        <div class="v4-layout-field-extra">
          {{ "property-property_detail-booking_setting_html_月折扣说明" | translate }}
          <!-- Monthly discounts apply to reservations that are 28 days or longer. 30% means 30% off. -->
        </div>
      </div>
    </div>
  }

  @if (isAirbnb) {
    <!-- Long stay discount -->
    @for (opt of formArrayOptions; track i; let i = $index) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ opt.label }}
          <!-- {{ "property-property_detail-booking_setting_html_长期折扣" | translate }} -->
          <!-- Long-term discount -->
        </div>
        <div class="v4-layout-field-control" [formArrayName]="opt.formArrayName">
          @for (
            item of priceForm.get(opt.formArrayName)["controls"];
            track trackFormArrayItem($index);
            let first = $first;
            let last = $last
          ) {
            <div class="v4-layout-field-row" [class.mt-3]="!first" [formGroupName]="$index">
              <div class="relative w-[120px]">
                <input
                  type="number"
                  nz-input
                  nzSize="large"
                  [placeholder]="'word.discount' | translate"
                  formControlName="discount" />
                <span class="percent">%</span>
              </div>
              <input
                class="w-[120px] mx-3"
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'word.days' | translate"
                formControlName="days" />
              <span>
                {{ "property-property_detail-booking_setting_html_天数" | translate }}
                <!-- days -->
              </span>

              @if (last) {
                <span class="ml-[18px] text-primary cursor-pointer" (click)="onAddItem(opt.formArrayName)"
                  >+ {{ "word.add" | translate }}</span
                >
              } @else {
                <span
                  class="ml-[18px] cursor-pointer"
                  nz-icon
                  nzType="close-circle"
                  nzTheme="outline"
                  (click)="onRemoveItem(opt.formArrayName, $index)"></span>
              }
            </div>
          }
          <div class="v4-layout-field-extra">
            {{ opt.desc }}
            <!-- Discount applied to bookings that last over a specified length of stay. This price supersedes weekly/monthly
          discounts. -->
          </div>
        </div>
      </div>
    }
  }

  <!-- <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_早鸟折扣" | translate }}
    </div>
    <div class="v4-layout-field-control" formGroupName="early_bird_discount">
      <div class="v4-layout-field-row">
        <div class="relative w-[180px]">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.discount' | translate"
            formControlName="discount" />
          <span class="percent">%</span>
        </div>
        <nz-select
          class="w-[150px] mx-3"
          nzSize="large"
          [nzPlaceHolder]="'word.days' | translate"
          [nzOptions]="optionsOfAirbnbEarlyBird"
          formControlName="days"></nz-select>
        <span>
          {{ "property-property_detail-booking_setting_html_天数" | translate }}
        </span>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_早鸟折扣说明" | translate }}
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_last_minute_discount" | translate }}
    </div>
    <div class="v4-layout-field-control" formGroupName="last_minute_discount">
      <div class="v4-layout-field-row">
        <div class="relative w-[180px]">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.discount' | translate"
            formControlName="discount" />
          <span class="percent">%</span>
        </div>
        <nz-select
          class="w-[150px] mx-3"
          nzSize="large"
          [nzPlaceHolder]="'word.days' | translate"
          [nzOptions]="optionsOfAirbnbLastMinute"
          formControlName="days"></nz-select>
        <span>
          {{ "property-property_detail-booking_setting_html_天数" | translate }}
        </span>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_last_minute_discount_desc" | translate }}
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_长期折扣" | translate }}
    </div>
    <div class="v4-layout-field-control" formGroupName="long_term_discount">
      <div class="v4-layout-field-row">
        <div class="relative w-[180px]">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.discount' | translate"
            formControlName="discount" />
          <span class="percent">%</span>
        </div>
        <input
          class="w-[150px] mx-3"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'word.days' | translate"
          formControlName="days" />
        <span>
          {{ "property-property_detail-booking_setting_html_天数" | translate }}
        </span>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_长期折扣说明" | translate }}
      </div>
    </div>
  </div> -->

  <div class="v4-layout-field" *ngIf="isAirbnb || isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_清洁费" | translate }}
      <!-- Cleaning fee -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[180px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'word.amount' | translate"
          formControlName="cleaning_fee" />
        <span class="ml-3">
          {{ "property-property_detail-booking_setting_html_stay" | translate }}
          <!-- / stay -->
        </span>
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isVrbo || isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_额外费用" | translate }}
      <!-- Extra guest fee -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[150px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'word.amount' | translate"
          formControlName="extra_guest_fee" />
        <span class="mx-3">
          {{ "property-property_detail-booking_setting_html_vrbo超出最大数量后" | translate }}
          <!-- /night, for each guest after -->
        </span>
        <input
          class="w-[150px]"
          type="number"
          nz-input
          nzSize="large"
          [placeholder]="'word.amount' | translate"
          [formControlName]="isVrbo ? 'extra_guest_number' : 'max_guests'" />
      </div>
      <div class="v4-layout-field-extra">
        <ng-container *ngIf="isVrbo">
          {{ "property-property_detail-booking_setting_html_vrbo超出最大数量后收费" | translate }}
        </ng-container>
        <ng-container *ngIf="isAirbnb">
          {{ "property-property_detail-booking_setting_html_airbnb超出最大数量后收费" | translate }}
        </ng-container>

        <!-- Charge this amount per extra guest, per night. Vrbo only accepts 1 or 2 in the "guest after" field. -->
      </div>
    </div>
  </div>

  <!-- pet fee -->
  @if (isAirbnb) {
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "property-property_detail-booking_setting_html_pet_fee" | translate }}
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            type="text"
            nz-input
            nzSize="large"
            class="w-[180px]"
            formControlName="pet_fee"
            [placeholder]="'word.amount' | translate" />
          <span class="mx-3">{{ "property-property_detail-booking_setting_html_stay" | translate }}</span>
        </div>
      </div>
    </div>
  }

  <div class="v4-layout-field" *ngIf="isAirbnb || isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_押金" | translate }}
      <!-- Security deposit -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[180px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'word.amount' | translate"
          formControlName="security_deposit" />
      </div>
      <div class="v4-layout-field-extra">
        <ng-container *ngIf="isVrbo">
          {{ "property-property_detail-booking_setting_html_vrobo押金说明" | translate }}
          <!-- With this option, you’re covered up to the amount you set for any damage to your property. You’ll have 14
          days after your guest’s stay to report damage. -->
        </ng-container>
        <ng-container *ngIf="isAirbnb">
          {{ "property-property_detail-booking_setting_html_airbnb押金说明" | translate }}
          <!-- Only displayed as security deposit in the price breakdown, will not be charged at the time of booking. -->
          <!-- <a [href]="depositLinkDoc" target="_blank">
            {{ "channel-account_html-了解更多" | translate }}
            Learn more
            ></a
          > -->
        </ng-container>
      </div>
    </div>
  </div>

  <div class="v4-layout-field !mt-[36px]">
    <div class="v4-layout-field-label">
      <button nz-button nzType="primary" nzSize="large" [nzLoading]="priceLoading" (click)="onSavePrice()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>

<!-- Booking Settiings -->
<div class="v4-layout-form" [formGroup]="bookingForm" *ngIf="isAirbnb || isVrbo">
  <div class="v4-layout-form-title">
    {{ "property-property_detail-booking_setting_html_预订设置" | translate }}
    <!-- Booking Settings -->
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb || isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_入住起始时间" | translate }}
      <!-- Check-in start time -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          nzSize="large"
          [nzOptions]="optionsOfCheckinStartTime"
          class="w-[180px]"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="check_in_start_time"></nz-select>
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_入住结束时间" | translate }}
      <!-- Check-in end time -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          nzSize="large"
          [nzOptions]="optionsOfCheckinEndTime"
          class="w-[180px]"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="check_in_end_time"></nz-select>
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb || isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_退房时间" | translate }}
      <!-- Check-out before -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          nzSize="large"
          [nzOptions]="optionsOfCheckoutTime"
          class="w-[180px]"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="check_out_before"></nz-select>
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb || isVrbo">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_立即预订" | translate }}
      <!-- Instant booking -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <label nz-checkbox formControlName="instant_booking">
          {{ "property-property_detail-booking_setting_html_启用" | translate }}
          <!-- Enabled -->
        </label>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_立即预订说明" | translate }}
        <!-- Automatically accept booking requests from all travelers for dates you have available, and add the bookings to
        your calendar. -->
      </div>
    </div>
  </div>

  <div class="v4-layout-field !mt-[36px]">
    <div class="v4-layout-field-label">
      <button nz-button nzType="primary" nzSize="large" [nzLoading]="bookingLoading" (click)="onSaveBookingSettings()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>

<!-- Availability Settings -->
<div class="v4-layout-form" [formGroup]="availabilityForm" *ngIf="isAirbnb || isVrbo">
  <div class="v4-layout-form-title">
    {{ "property-property_detail-booking_setting_html_房态设置" | translate }}
    <!-- Availability Settings -->
  </div>

  <div class="v4-layout-field">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_最少入住" | translate }}
      <!-- Minimum stay -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input
          class="w-[180px]"
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'word.amount' | translate"
          formControlName="minimum_stay" />
      </div>
    </div>
  </div>

  @if (isAirbnb) {
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "property-property_detail-booking_setting_html_最多入住" | translate }}
        <!-- Maximum stay -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            class="w-[180px]"
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'word.amount' | translate"
            formControlName="maximum_stay" />
        </div>
        <div class="v4-layout-field-extra">
          <div class="my-[12px]">
            <label nz-checkbox formControlName="allow_rtb_above_max_nights"
              >allow request to book above maximum stay</label
            >
          </div>
          <div>
            Allow guests to create Request to Book reservations with a length of stay longer than the maximum stay.
          </div>
        </div>
      </div>
    </div>
  }

  <div class="v4-layout-field">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_通知" | translate }}
      <!-- Advance notice -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-cascader
          *ngIf="isAirbnb"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          nzExpandTrigger="hover"
          class="w-full"
          nzSize="large"
          [nzOptions]="optionsOfAdvanceNotice"
          [nzLabelRender]="renderTpl"
          formControlName="advance_notice"></nz-cascader>
        <ng-template #renderTpl let-labels="labels">
          <ng-container *ngFor="let label of labels; let isLast = last">
            <span *ngIf="isLast">{{ label }}</span>
          </ng-container>
        </ng-template>
        <nz-select
          *ngIf="isVrbo"
          class="w-[180px]"
          nzSize="large"
          [nzOptions]="optionsOfAdvanceNotice"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="advance_notice"></nz-select>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_通知说明" | translate }}
        <!-- Define how close you can accept bookings. -->
      </div>
    </div>
  </div>

  <div class="v4-layout-field">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_可订窗口" | translate }}
      <!-- Availability window -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          class="w-full"
          nzSize="large"
          [nzOptions]="optionsOfAvailabilityWindow"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          [nzDropdownMatchSelectWidth]="false"
          formControlName="availability_window"></nz-select>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_可订窗口说明" | translate }}
        <!-- Define how far you can accept bookings. -->
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_准备时间" | translate }}
      <!-- Preparation time -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          class="w-full"
          nzSize="large"
          [nzOptions]="optionsOfPreparationTime"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          [nzDropdownMatchSelectWidth]="false"
          formControlName="preparation_time"></nz-select>
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_可入住日" | translate }}
      <!-- Days of week check in -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          class="w-full"
          nzSize="large"
          [nzOptions]="optionsOfDaysOfCheck"
          nzMode="multiple"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="days_of_week_check_in"></nz-select>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_可入住日说明" | translate }}
        <!-- Guests won't be able to book your place if their stay starts on these days. -->
      </div>
    </div>
  </div>

  <div class="v4-layout-field" *ngIf="isAirbnb">
    <div class="v4-layout-field-label">
      {{ "property-property_detail-booking_setting_html_可退房日" | translate }}
      <!-- Days of week check out -->
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <nz-select
          class="w-full"
          nzSize="large"
          [nzOptions]="optionsOfDaysOfCheck"
          nzMode="multiple"
          [nzPlaceHolder]="'placeholder.choose' | translate"
          formControlName="days_of_week_check_out"></nz-select>
      </div>
      <div class="v4-layout-field-extra">
        {{ "property-property_detail-booking_setting_html_可退房日说明" | translate }}
        <!-- Guests won't be able to book your place if their stay ends on these days. -->
      </div>
    </div>
  </div>

  <div class="v4-layout-field !mt-[36px]">
    <div class="v4-layout-field-label">
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="availabilityLoading"
        (click)="onSaveAvailability()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
